// Copyright (c) Docugami, Inc. All rights reserved.

import { Dispatch } from 'redux';
import { DownloadFileAARequest } from '../../networking/api';
import axios from 'axios';
import { reportErrorEncountered } from "../authentication/actions";
import { Config } from "../../config";
import { FileUploaderInstance, FileUploadRequest } from "filemanager/FileUploader";
import { FileManagerInstance } from "filemanager/FileManager";

// builds full filename from given file, path, and current directory
function getFilePath(file: File, path: string | null, rootPath: string): string {
    let filename = '';
    if (!!path) {
        filename = path.substring(1);
    } else {
        // @ts-ignore
        filename = !!file.webkitRelativePath ? file.webkitRelativePath : file.name;
    }

    filename = rootPath + filename;
    filename = filename.replace('\\', '/');
    return filename;
}

/**
 * Builds a list of indexed files from given files and paths and adds them to be uploaded in file manager.
 *
 * @param files the files to be uploaded
 * @param paths the corresponding paths of each file to be uploaded
 */
export function addFilesForUpload(files: File[], paths: string[] = [], rootPath: string = '', uploadCb?: (items: any) => void, docsetId?: string): void {
    const requests: FileUploadRequest[] = []
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const path = paths[i] ?? null;

        const filePath = getFilePath(files[i], path, rootPath);

        const request: FileUploadRequest = {
            file: file,
            targetPath: filePath,
            docsetId: docsetId
        };

        requests.push(request);
    }

    if (!!uploadCb) {
        uploadCb(requests);
    }
    else {
        FileUploaderInstance.upload(requests);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deleteFile(paths: string[]): ((dispatch: Dispatch<any>) => Promise<void>) {
    return async function (dispatch: Dispatch<any>) {
        try {
            await FileManagerInstance.delete(paths);
        }
        catch (error) {
            dispatch(reportErrorEncountered('deleteFile', error as Error));
        }
    }
}

export async function downloadAssistedAuthoringDocument(folderId: string, fileName: string) {
    const url = `${Config.fileManagerApiUrl}/FileManager/DownloadFileAA`;
    const request: DownloadFileAARequest = {
        folderId: folderId,
        addinGuid: '',
        version: '',
        storeType: '',
        store: '',
    };

    const response = await axios.post(url, request, { responseType: "blob" });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(response.data);
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(a.href);
}
